export default "__VITE_ASSET__8c8493ed__"